import React from 'react';
import styles from './Modal.module.css';
import PropTypes from 'prop-types';

const Modal = (props) => {

	let mode = props.open ? [styles.modal, styles.open].join(" ") : styles.modal;

	return (
		<div className={mode}>
			<div className={styles.background} onClick={() => props.close(false)}/>
			<div className={styles.body} style={{top: `${window.pageYOffset + 50}px`}}>
				<div className={styles.close} onClick={() => props.close(false)}><i className="fas fa-times"/></div>
				<div className={styles.icon}><i className="fad fa-tools"/></div>
				<div className={styles.title}>Please bear with us during construction.</div>
				<div className={styles.subtitle}>We are still assisting customers and would love to hear from you. Please feel free to contact us
					with any questions you may have.
				</div>
				<div className={styles.phone}>(805) 736 - 1729</div>
				<div className={styles.address}>502 B North 8th Street | Lompoc, CA | 93436</div>
			</div>
		</div>
	);
};

Modal.propTypes = {
	open: PropTypes.bool.isRequired
};

export default Modal;